export type AdminCloudLoggingConfig = {
  projectId?: string;
  cloudRunServiceName?: string;
};

function quote(value: string): string {
  return JSON.stringify(value);
}

function createLogsExplorerUrl(projectId: string, query: string): string {
  return `https://console.cloud.google.com/logs/query;query=${encodeURIComponent(query)}?project=${encodeURIComponent(projectId)}`;
}

function createBaseClauses(config: AdminCloudLoggingConfig): string[] {
  const clauses: string[] = [];

  if (config.cloudRunServiceName && config.cloudRunServiceName.length > 0) {
    clauses.push('resource.type="cloud_run_revision"');
    clauses.push(`resource.labels.service_name=${quote(config.cloudRunServiceName)}`);
  }

  return clauses;
}

export function buildCloudLoggingRequestLogsUrl(
  config: AdminCloudLoggingConfig,
  requestId: string | undefined,
): string | undefined {
  if (!config.projectId || !requestId) {
    return undefined;
  }

  const clauses = createBaseClauses(config);
  clauses.push(`(jsonPayload.requestId=${quote(requestId)} OR textPayload:${quote(requestId)})`);

  return createLogsExplorerUrl(config.projectId, clauses.join("\n"));
}

export type BuildCloudLoggingSimilarFailuresInput = AdminCloudLoggingConfig & {
  feature: string;
  useCase: string;
  errorCode: string;
};

export function buildCloudLoggingSimilarFailuresUrl(
  input: BuildCloudLoggingSimilarFailuresInput,
): string | undefined {
  if (!input.projectId) {
    return undefined;
  }

  const clauses = createBaseClauses(input);
  clauses.push(`jsonPayload.feature=${quote(input.feature)}`);
  clauses.push(`jsonPayload.useCase=${quote(input.useCase)}`);
  clauses.push(`jsonPayload.errorCode=${quote(input.errorCode)}`);

  return createLogsExplorerUrl(input.projectId, clauses.join("\n"));
}
